export default __webpack_public_path__ + "static/media/phoneDetailTextMb5.33082e7e.png";